export const ENROLLMENT_VERSION_1 = 1;
export const ENROLLMENT_VERSION_2 = 2;
